// extracted by mini-css-extract-plugin
var _1 = "courseDetail-module_accordionDetails__eb4zfv";
var _2 = "courseDetail-module_accordionHeader__LMPsNO";
var _3 = "courseDetail-module_btn__qeQVBN";
var _4 = "courseDetail-module_btnEmpty__vQdawB";
var _5 = "courseDetail-module_container__KkP4Sn";
var _6 = "courseDetail-module_detailItems__au1raA";
var _7 = "courseDetail-module_item__Tf4tPF";
var _8 = "courseDetail-module_items__CYyKtw";
var _9 = "courseDetail-module_notificationContainer__dtJyak";
var _a = "courseDetail-module_notificationText___WPZVy";
var _b = "courseDetail-module_semesterName__BlBcrd";
export { _1 as "accordionDetails", _2 as "accordionHeader", _3 as "btn", _4 as "btnEmpty", _5 as "container", _6 as "detailItems", _7 as "item", _8 as "items", _9 as "notificationContainer", _a as "notificationText", _b as "semesterName" }
